import React from "react";
import { Radio, Group, Text } from "@mantine/core";

const RadioGroupComp = ({
  label,
  value,
  options = [],
  setValue,
  disabled = false,
  readOnly = false,
  isRequired = false,
  error,
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      {/* Label */}
      {label && (
        <Text weight={500} mb={4}>
          {label} {isRequired && <span style={{ color: "red" }}>*</span>}
        </Text>
      )}

      {/* Radio buttons */}
      <Radio.Group
        value={value}
        onChange={(val) => !disabled && !readOnly && setValue(val)}
        disabled={disabled || readOnly}
        error={error}
      >
        <Group>
          {options.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              label={option.label}
            />
          ))}
        </Group>
      </Radio.Group>

      {error && (
        <Text color="red" size="sm" mt={4}>
          {error}
        </Text>
      )}
    </div>
  );
};

export default RadioGroupComp;
